import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
// import { Api } from '@/service';

//restful api
import { agent as history } from '@/service/api/history'
import { group } from '@/service/api/manager'
import { license } from '@/service/api/billing'


const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

const i18n_fields = {
  EN: [
   { key: 'created_at', sortable: true, label: 'Installed_at' },
   { key: 'type', sortable: true, label: 'Solution'},
   { key: 'deleted_at', sortable: true, label: 'Deleted_at' },
   { key: 'reason', sortable: false, label: 'Reason'},
   { key: 'agent', sortable: false, label: 'Agent' },
   { key: 'group', sortable: false, label: 'Group' },
   { key: 'service', sortable: false, label: 'Service', thStyle: 'width: 10%' },
  ],
  KO: [
    { key: 'created_at', sortable: true, label: '설치된 날짜' },
    { key: 'type', sortable: true, label: '보안설정'},
    { key: 'deleted_at', sortable: true, label: '삭제된 날짜' },
    { key: 'reason', sortable: false, label: '이유'},
    { key: 'agent', sortable: false, label: '에이전트' },
    { key: 'group', sortable: false, label: '회사명' },
    { key: 'service', sortable: false, label: '서비스', thStyle: 'width: 10%' },
  ]
}

// props explain
// auto_refresh[default=false] : auth sync enable or disable, value is boolean
// user : this component to user list, using by user dependency

export default {
  name : "InstallList",
  props: ['user', 'auto_refresh'],
  components: { DatePicker },
  data: () => ({
    hide_del : true,
    modal_service : false,
    modal_agent : false,
    modal_group : false,
    modal_service_info : {},
    modal_agent_info : {},
    modal_group_info : {},
    custom,
    so : default_opt(),
    sync : { interval : 15, stop : false, th : undefined, enable : false },
    summaryData : { good : 0, bad : 0 },
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      // let f = []

      // f = i18n_fields[this.i18n]
      // return this.user ? f.splice(0, 3) : f
      return i18n_fields[this.i18n]
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_del'] = 'false';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      if(k == 'type') {
        return { name : k, value : v, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        // target : 'history.agent', cmd : 'list',
        body : { sort : [{ name : 'is_del',op : 'asc' }, { name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      // if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.user) { so.body.and.push({ name : 'group_id', value : this.user.id, op : '=' }) }
      if( this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start created_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end created_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'deleted_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("start deleted_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'deleted_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.warn("end deleted_at is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      // return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
      return history.listAgent(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail_group: function(item) {
      console.info(item);
      // Api.Manager_Call('group','detail',{ id : item.group_id })
      group.detailGroup({ id : item.group_id })
        .then(rs => {
          this.modal_group_info = rs.body
          // this.modal_group_info = Object.assign({}, this.modal_group_info, rs.body)
          this.modal_group = true
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail_service: function(item) {
      console.info(item);
      // Api.Manager_Call('partner.license','detail',{ id : item.service_id })
      license.detailLicense({ id : item.service_id })
        .then(rs => {
          this.modal_service_info = rs.body
          // this.modal_service_info = Object.assign({}, this.modal_service_info, rs.body)
          this.modal_service = true
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail_agent: function(item) {
      console.info(item);
      // Api.Manager_Call('history.agent','info',{ id : item.agent_id, type : item.type })
      history.infoAgent({ id : item.agent_id, type : item.type })
        .then(rs => {
          this.modal_agent_info = rs.body
          // this.modal_agent_info = Object.assign({}, this.modal_agent_info, rs.body)
          this.modal_agent = true
        })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) { console.info(item); this.$router.push(`/log/install/${item.id}`); },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
    // summary() {
    //   let and = [];
    //   let id = undefined;
    //   if(this.user) { id = this.user.id; and.push({ name : 'user_id', value : id, op : '='}) }
    //   Api.Manager({ target : 'log.login', cmd : 'summary.user', body : { and : and, or : [], sort : [] } })
    //     .then(rs => { this.summaryData = Object.assign(this.summaryData, rs.body) })
    //     .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    // },
  },
  created() { console.log('log.install.vue', 'created'); },
  destroyed() { console.log('log.install.vue', 'destroyed'); },
  mounted() {
    console.log('log.install.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    setTimeout(this.summary, 1000)
  },
}